export enum ReadyRouteStatusEnum {
    DRAFT = 'draft',
    /** Submitted by a partner author; waiting for admin review. */
    NEED_REVIEW = 'need_review',
    /** Returned to the author with feedback. */
    REJECTED = 'rejected',
    PUBLISHED = 'published',
}
